import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { IRetencaoFonte } from "../../interfaces/IRetencaoFonte";
import RetencaoFonteService from "../../services/RetencaoFonteService";
import Swal from 'sweetalert2';
import RetencaoFonteModal from "./RetencaoFonteModal";
import RetencaoFonteTabela from "./RetencaoFonteTabela";

const RetencaoFonte = () => {

  const intl = useIntl();
  const [retencoesFonte, setRetencoesFonte] = useState<IRetencaoFonte[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [retencaoFonteSelecionada, setRetencaoFonteSelecionada] = useState<IRetencaoFonte>({} as IRetencaoFonte);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [paginaCarregada, setPaginaCarregada] = useState<boolean>(false);
  const { classes } = useLayout();
  const columns = [
    {
      name: 'Cód. tributo',
      selector: (row: IRetencaoFonte) => row['codigo'],
      sortable: true,
    },
    {
      name: 'Alíquota',
      selector: (row: IRetencaoFonte) => row['aliquota'],
      sortable: true,
    },
    {
      name: 'Descrição',
      selector: (row: IRetencaoFonte) => row['descricao'],
      sortable: true,
    },
    {
      name: 'Ações',
      cell: (row: IRetencaoFonte) => <AcoesRetencaoFonte excluirRetencao={excluirRetencao} editarRetencao={(retencaoFonte: IRetencaoFonte) => {
        setModalTitle('Editar Retenção na Fonte');
        setRetencaoFonteSelecionada(retencaoFonte);
        toggleModal();
      }} retencaoFonte={row} />
    }
  ];

  useEffect(() => {
    setTimeout(() => {
      carregarInformacoes();
    }, 1000)
  }, []);
  
  async function carregarInformacoes() {
    setPaginaCarregada(false);
    await RetencaoFonteService.obterTodos(x => setRetencoesFonte(x));
    setPaginaCarregada(true);
  }

  function AcoesRetencaoFonte({ retencaoFonte, excluirRetencao, editarRetencao }: { retencaoFonte: IRetencaoFonte, excluirRetencao: (retencaoFonte: IRetencaoFonte) => void, editarRetencao: (retencaoFonte: IRetencaoFonte) => void }) {
    return <div data-tag="allowRowEvents">
      <i onClick={() => { editarRetencao(retencaoFonte) }} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}/>
      <i onClick={() => { excluirRetencao(retencaoFonte) }} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}/>
    </div>
  }

  function toggleModal(recarregarInformacoes?: boolean): void {
    if (recarregarInformacoes) {
      carregarInformacoes();
    }

    setShowModal(!showModal);

    if (showModal) {
      setTimeout(() => { 
        setRetencaoFonteSelecionada({} as IRetencaoFonte); 
      }, 300)
    }
  }

  async function excluirRetencao(evento: IRetencaoFonte) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-modal-excluir ms-5',
        cancelButton: 'btn btn-modal-cancelar'
      },
      buttonsStyling: false
    });
    const result = await swalWithBootstrapButtons.fire({
      title: 'Excluir Retenção na Fonte',
      text: `Você realmente deseja excluir essa Retenção?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: `Excluir`,
      reverseButtons: true
    });

    if (result.isConfirmed) {
      await RetencaoFonteService.excluir(evento.id, () => setRetencoesFonte(retencoesFonte.filter(e => e.id !== evento.id)), 'Retenção na Fonte excluído com sucesso');
    }
  }

  return <>
    <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.RETENCAO_NA_FONTE' })}</PageTitle>
    <div className='toolbar' id='kt_toolbar'>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
        <DefaultTitle />
        <RetencaoFonteModal retencao={retencaoFonteSelecionada} title={modalTitle} show={showModal} toggleModal={toggleModal} />
        <div className='d-flex align-items-center py-1'>
          <button onClick={() => {
            setModalTitle('Adicionar Retenção na Fonte');
            setRetencaoFonteSelecionada({} as IRetencaoFonte);
            toggleModal();
          }} className='btn btn-sm btn-primario'>
            <i className="icon-lg text-white fas fa-plus"/>
            <span style={{ verticalAlign: 'middle' }}> RETENÇÃO </span>
          </button>
        </div>
      </div>
    </div>
    
    { paginaCarregada ? retencoesFonte.length > 0 ? <RetencaoFonteTabela colunas={columns} itens={retencoesFonte} /> : <h2>Não possuem fisco para serem exibidos</h2> : <p>Carregando...</p> }
  </>
};

export default RetencaoFonte;